var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H23C24.6569 0 26 1.34315 26 3V15C26 16.6569 24.6569 18 23 18H3C1.34315 18 0 16.6569 0 15V3ZM12.2929 2.79289C12.6834 2.40237 13.3166 2.40237 13.7071 2.79289L18.7071 7.79289C19.0976 8.18342 19.0976 8.81658 18.7071 9.20711C18.3166 9.59763 17.6834 9.59763 17.2929 9.20711L14 5.91421L14 14.5C14 15.0523 13.5523 15.5 13 15.5C12.4477 15.5 12 15.0523 12 14.5L12 5.91421L8.70711 9.20711C8.31658 9.59763 7.68342 9.59763 7.29289 9.20711C6.90237 8.81658 6.90237 8.18342 7.29289 7.79289L12.2929 2.79289Z",
    fill: "#6CE680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenOn);
export default __webpack_public_path__ + "static/media/screen_on.4ce2e612dd69a0b21a9b24e06d04d5eb.svg";
export { ForwardRef as ReactComponent };